'use client'

import { createContext, Dispatch, SetStateAction, useContext, useMemo, useState } from 'react'

interface SealedResultContext {
  sealedResult: string
  setSealedResult: Dispatch<SetStateAction<string>>
}

const SealedResultContext = createContext<SealedResultContext>({
  sealedResult: '',
  setSealedResult: () => '',
})

export const SealedResultContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [sealedResult, setSealedResult] = useState('')

  const value = useMemo(() => ({ sealedResult, setSealedResult }), [sealedResult])

  return <SealedResultContext.Provider value={value}>{children}</SealedResultContext.Provider>
}

export const useSealedResultContext = () => useContext(SealedResultContext)
